// extracted by mini-css-extract-plugin
module.exports = {"ListOfForumsRight":"qn_a","ListOfForumsRight__brandDaysPosts":"qn_b bhu_rq"};